export function counter<T>(xs: Array<T>) {
  return xs.reduce(function (rv, x: T) {
    return rv.has(x) ? rv.set(x, rv.get(x) + 1) : rv.set(x, 1);
  }, new Map<T, number>());
}
